import { render, staticRenderFns } from "./HrDocumentEditor.vue?vue&type=template&id=94113374&"
import script from "./HrDocumentEditor.vue?vue&type=script&lang=js&"
export * from "./HrDocumentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports